import React, { Suspense } from 'react';

import { Router } from './router';

import { ErrorBoundary } from 'components/ErrorBoundary';
import { Loader } from 'components/Loader';

export const App = () => {
  return (
    // OUTSIDE Suspense, deliberately. An error boundary only catches what is
    // thrown BELOW it, and a component that throws while suspended -- a failed
    // lazy chunk, most obviously -- throws from the Suspense boundary itself.
    // Inside, that error would escape to the root and blank the console, which
    // is the exact failure this exists to stop.
    <ErrorBoundary>
      <Suspense fallback={<Loader />}>
        <Loader />
        <Router />
      </Suspense>
    </ErrorBoundary>
  );
};
